import styled, { css } from 'styled-components'

interface Props {
  height?: string
  border?: boolean
}

const verticalSpace = css<Props>`
  ${({ height, theme }) => {
    switch (height) {
      case 'xxxs':
        return theme.space.s025
      case 'xxs':
        return theme.space.s050
      case 'xs':
        return theme.space.s100
      case 'sm':
        return theme.space.s150
      case 'md':
        return theme.space.s300
      case 'lg':
        return theme.space.s400
      case 'xl':
        return theme.space.s500
      case 'xxl':
        return theme.space.s600
      case 'xxxl':
        return theme.space.s700
      case 'xxxxl':
        return theme.space.s800
      case 'xxxxxl':
        return theme.space.s900
      case 'xxxxxxl':
        return theme.space.s1000
      default:
        return theme.space.s200
    }
  }}
`

const Separator = styled.div<Props>`
  width: 100%;
  height: 1px;

  margin: ${verticalSpace} 0;

  ${({ border }) =>
    border &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.gray.s300};
    `}
`
export default Separator
